import React from 'react';
import ModalForm from './ui/ModalForm';
import { FormField } from '../types';
import { Form } from 'antd';
import { useChangePasswordStore, useUpdateData } from '../hooks';
import { ChangePassword } from '../types/auth.model';

const ChangePasswordModal = ({
  userId,
  visible,
  onClose,
}: {
  userId?: string;
  visible: boolean;
  onClose: () => void;
}) => {
  const [form] = Form.useForm();
  const changePasswordStore = useChangePasswordStore();

  const fields: FormField[] = [
    {
      name: 'newPassword',
      label: 'New Password',
      type: 'password',
      rules: [
        { required: true, message: 'Please enter password' },
        { min: 6, message: 'Password must be at least 6 characters' }, // Minimum length validation
      ],
    },
    {
      name: 'confirmPassword',
      label: 'Confirm Password',
      type: 'confirmPassword',
    },
  ];

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const { mutate: mutateUpdate } = useUpdateData<ChangePassword>(
    `/users/reset-password`,
  );

  const onFinish = (values: {
    newPassword: string;
    confirmPassword: string;
  }) => {
    const jsonData = {
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
    };
    mutateUpdate({ id: userId!, form: jsonData });
  };

  return (
    <>
      <ModalForm
        visible={visible}
        onClose={handleClose}
        formFields={fields}
        onFinish={onFinish}
        form={form}
        data={changePasswordStore.data}
        setData={changePasswordStore.setData}
      />
    </>
  );
};

export default ChangePasswordModal;
